const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0625,0,0,0.0625,4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.837,0 0,114.837 0,256C0,397.163 114.837,512 256,512C397.163,512 512,397.163 512,256C512,114.837 397.163,0 256,0ZM256,469.333C138.368,469.333 42.667,373.632 42.667,256C42.667,138.368 138.368,42.667 256,42.667C373.632,42.667 469.333,138.368 469.333,256C469.333,373.632 373.632,469.333 256,469.333Z",
    style: {
      fill: "rgb(215,58,31)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.667,344.96C236.736,345.195 225.515,356.416 225.28,370.347C225.259,370.774 225.259,371.222 225.28,371.648C225.771,385.664 237.504,396.629 251.52,396.16L250.667,396.16C264.747,395.925 276.054,384.448 276.054,370.347C275.712,356.459 264.555,345.301 250.667,344.96Z",
    style: {
      fill: "rgb(215,58,31)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.573,116.693C225.493,115.797 196.437,127.658 175.573,149.333C173.162,152.362 171.882,156.138 171.946,160C172.053,169.451 179.562,177.152 189.013,177.493C193.408,177.514 197.653,175.914 200.96,173.013C214.187,159.296 232.469,151.594 251.52,151.68C280.32,151.68 294.187,167.253 294.187,185.6C294.187,224.853 224.427,229.76 224.427,280.747C224.427,293.12 232.107,315.947 248.107,315.947L248.534,315.947C257.131,315.947 264.107,308.971 264.107,300.374C264.107,294.614 260.054,289.707 260.054,283.947C260.054,245.547 335.147,240.214 336.854,180.694C336.853,144.427 306.133,116.693 255.573,116.693Z",
    style: {
      fill: "rgb(215,58,31)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.fcfa8d724fffb9e89cd74211e45e2ef9.svg";
export { ForwardRef as ReactComponent };